Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.grid = void 0;
var _getREM = require("../getREM");
var grid = exports.grid = {
  maxTextWidth: (0, _getREM.getREM)(60),
  maxTextBlockWidth: (0, _getREM.getREM)(54.25),
  maxInputWidth: (0, _getREM.getREM)(31.25),
  maxBoxWidth: (0, _getREM.getREM)(38),
  maxNotificationWidth: (0, _getREM.getREM)(54.25),
  maxContentWidth: (0, _getREM.getREM)(90),
  maxCardWidth: (0, _getREM.getREM)(29),
  maxColumnWidth: (0, _getREM.getREM)(45.625)
};